import Bullet from "../Assets/Bullet.png"
const BulletCard=({text})=>
{
    return(
        <div className="flex items-center gap-[10px] justify-start sm:mb-[20px] lg:mb-[20px]">
            <img className="w-[12px] h-[12px]" src={Bullet}></img>
            <p className="sm:text-[16px] lg:text-[18px] text-[#656565] text-black font-[400] leading-[22px]">{text}</p>
        </div>
    )
}
export default BulletCard